{
  "#LOGIN": {
    "TITLE": "Login",
    "USERNAME": "Username",
    "PASSWORD": "Password",
    "REMEMBER": "Remember me (do not use on public devices!)",
    "LOGIN": "Login",
    "SCAN": "Scan",
    "MESSAGES": {
      "FAILED": {
        "SUBJECT": "Login Failed",
        "UNAUTHORIZED": "Username and/or password are incorrect",
        "NO_CONNECTION": "Unable to connect to the server. Please check your internet connection or try again later.",
        "UNKNOWN": "An unexpected error has occurred!"
      },
      "EXPIRED": "You have been automatically logged out due to inactivity",
      "LOGOUT": "You have been successfully logged out"
    },
    "SETTINGS": "Settings",
    "BACK": "<< Back to Login"
  },
  "#FORGOT_PASSWORD": {
    "TITLE": "Forgot Password",
    "EMAIL": "Email",
    "SUBMIT": "Request recovery link",
    "BACK": "Back to Login"
  },
  "#LOGOUT": {
    "TITLE": "Logout"
  }
}
